class HeroMegamenu {
  constructor() {
    this.MEGAMENU_OPEN_CLASS = 'is-megamenu-open';
    this.MIN_WIDTH = 1024;
    this.init();
  }

  isDesktop() {
    return window.innerWidth >= this.MIN_WIDTH;
  }

  init() {
    const heroLogo = document.querySelector('.hero-banner__logo');
    const header = document.getElementById('header');

    if (!header) {
      return;
    }

    // Handler per aggiungere/rimuovere la classe
    const addMegamenuClass = () => {
      if (this.isDesktop()) {
        header.classList.add(this.MEGAMENU_OPEN_CLASS);
      }
    };

    const removeMegamenuClass = () => {
      if (this.isDesktop()) {
        header.classList.remove(this.MEGAMENU_OPEN_CLASS);
      }
    };

    // Mouseover sul logo hero
    if (heroLogo) {
      heroLogo.addEventListener('mouseenter', addMegamenuClass);
      heroLogo.addEventListener('mouseleave', removeMegamenuClass);
    }

    // Mouseover sull'header
    header.addEventListener('mouseenter', addMegamenuClass);
    header.addEventListener('mouseleave', removeMegamenuClass);
  }
}

// Inizializza quando il DOM è pronto
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new HeroMegamenu();
  });
} else {
  new HeroMegamenu();
}

